export default "__VITE_ASSET__Uk9s$KWZ__"